import React from 'react';
import clsx from 'clsx';
import api from '../../../../services/apiService';
import { findIndexIfArgExists } from '../../../../validations/validations';
import {
    MyTableCell1,
} from "../../../../styling/Styles";

/**
 *  This component returns a cell that contains an image if the corresponding project is 
 *  visible or no visible.
 */
const ShowHideCell = ({index, showStatus, setShowStatus,row, setPressVisibilityButton, response, hiddenProjects, setHiddenProjects}) => {
   
    /**
     * This function is fired when we click on the image of the cell.
     * It changes the state of the visibility with a state that contains 
     * a boolean value, and updates server.
    */
    const changeState = () => {
        setShowStatus(!showStatus);
        let tempHiddenProjects = hiddenProjects;
        /**
         * Find if project belongs to array with hiddenProjects.
         * If it belongs then we take the index inside the array,
         * else we take -1.
        */
        const indexArg = findIndexIfArgExists(row._id, hiddenProjects);
        
        if(  indexArg === -1 ){
            /**
             * If project does not belong to hiddenProjects then we update the array with hiddenProjects
             * and we add the id if the current project to the hiddenProjects.
            */
            api.updateUser({userPreferences : { 
                hiddenProjects: [...hiddenProjects, row._id],
                visibilityFilter: response.data.visibilityFilter,
                roleFilter: response.data.roleFilter,
                statusFilter: response.data.statusFilter
            }});
            tempHiddenProjects = [...tempHiddenProjects, row._id];
        }
        else{
            /**
             * If project belongs to hiddenProjects then we update the array with hiddenProjects and we 
             * remove the id of the current project of the hiddenProjects.
             */
            api.updateUser({userPreferences: {
                hiddenProjects: hiddenProjects.filter( (project, indexProj) => indexProj !== indexArg),
                visibilityFilter: response.data.visibilityFilter,
                roleFilter: response.data.roleFilter,
                statusFilter: response.data.statusFilter                   
            }});
            tempHiddenProjects = tempHiddenProjects.filter( (project, indexProj) => indexProj !== indexArg)
        }
        setPressVisibilityButton(true);
        setHiddenProjects(tempHiddenProjects);
       
    }

    return(
        <MyTableCell1
            scope="row"
            padding="none"
            align="center"
            className={clsx("teamSelector")}
            style={
                index % 2 === 0
                ? null
                : { backgroundColor: "#CFD8E0" }
            }
            >
            
            {
                showStatus === true ? 
                <div id='displayCell' onClick = {changeState} aria-hidden="true">
                    <i className={clsx('fas', 'fa-eye')} />
                </div>
                :
                <div id='hideCell' onClick = {changeState} aria-hidden="true">
                    <i className={clsx('fas', 'fa-eye-slash')} />
                </div>
            }
        </MyTableCell1>
    )
    
}

export default ShowHideCell;